<form class="form" *ngIf="articleModel">
  <div class="input-group">
    <label>Draft</label>
    <p-toggleSwitch [(ngModel)]="articleModel.draft" name="draft"></p-toggleSwitch>
  </div>
  <div class="input-group">
    <label>Destination</label>
    <p-select
      [options]="destinations$ | async"
      [(ngModel)]="articleModel.destinationId"
      optionLabel="country"
      optionValue="id"
      name="destinations"
    ></p-select>
  </div>
  <div class="input-group">
    <label>Slug</label>
    <input
      pInputText
      maxlength="30"
      type="text"
      placeholder="Slug"
      [(ngModel)]="articleModel.slug"
      name="slug"
    />
  </div>
  <div class="input-group">
    <label>Lieu</label>
    <input
      pInputText
      type="text"
      placeholder="Lieu"
      [(ngModel)]="articleModel.place"
      name="place"
      [disabled]="articleModel.articleType === ArticleType.Setup"
    />
  </div>
  <div class="input-group">
    <label>Nom de l'article</label>
    <input
      pInputText
      type="text"
      [(ngModel)]="articleModel.name"
      placeholder="Nom de l'article"
      name="articleName"
    />
  </div>
  <div class="input-group">
    <label>Catégorie de l'article</label>
    <p-select
      [options]="articleCategories"
      [(ngModel)]="articleModel.category"
      name="category"
    ></p-select>
  </div>
  <div class="input-group">
    <label>Latitude</label>
    <input
      pInputText
      type="text"
      [(ngModel)]="articleModel.lat"
      placeholder="Latitude"
      name="latitude"
    />
  </div>
  <div class="input-group">
    <label>Longitude</label>
    <input
      pInputText
      type="text"
      [(ngModel)]="articleModel.lng"
      placeholder="Longitude"
      name="longitude"
    />
  </div>
  <div class="input-group">
    <label>Afficher la table des matières</label>
    <p-toggleSwitch [(ngModel)]="articleModel.hasSummary" name="summary"></p-toggleSwitch>
  </div>
  <div class="input-group">
    <label>Intro de l'article</label>
    <app-text-editor
      [(ngModel)]="articleModel.description"
      [name]="articleModel.id + 'description'"
    ></app-text-editor>
  </div>
  <!-- <div class="input-group">
    <label>Tags</label>
    <p-multiSelect
      [options]="tags$ | async"
      [(ngModel)]="articleModel.tags"
      optionLabel="tagString"
      name="tags"
    >
    </p-multiSelect>
  </div> -->
  <div class="input-group">
    <label>Date</label>
    <p-datepicker [(ngModel)]="articleModel.date" name="date"></p-datepicker>
  </div>
  <div class="input-group">
    <label>Photo de couverture</label>
    <p-fileUpload
      mode="basic"
      [customUpload]="true"
      [auto]="true"
      (onSelect)="onFileChanged($event)"
      id="coverPic"
      name="coverPic"
      accept="image/*"
      chooseLabel="Ajouter une photo de couverture"
    ></p-fileUpload>
    <img
      *ngIf="articleModel.coverPicture?.uploadSrc"
      [src]="articleModel.coverPicture?.uploadSrc"
      alt="cover picture"
    />
  </div>
</form>
